.thankYou {
  position: relative;
}

.note {
  padding-bottom: 15px;
  text-align: center;
}

.close {
  position: absolute;
  top: -30px;
  right: 0;
}

.button {
  width: 100%;
}
